import PrimaryButton from '../atoms/PrimaryButton';
import Modal from './Modal';

type Properties = {
    title: string;
    text: string;
    confirmLabel: string;
    onConfirmClicked: () => void;
    dismissLabel?: string;
    onDismissClicked?: () => void;
};

const ConfirmPopup = (props: Properties) => {
    const { title, text, dismissLabel, confirmLabel, onDismissClicked, onConfirmClicked } = props;

    let dismissButton = <></>;
    if (dismissLabel && onDismissClicked) {
        dismissButton = <button className="button dismiss" onClick={onDismissClicked}>{dismissLabel}</button>;
    }

    return (
        <Modal>
            <div className="popup-modal">
                <div>
                    <h3>
                        {title}
                    </h3>
                    {text}
                </div>
                <div className="popup-modal-button-bar">
                    {dismissButton}
                    <PrimaryButton className="button confirm" onClick={onConfirmClicked} label={confirmLabel} />
                </div>
            </div>
        </Modal>
    );
};
export default ConfirmPopup;